import React from 'react';

const PromotionsLoader = () => {
  return (
    <section className='promotions'>
      <div className='promotions__container'>
        <div className='promotions__cards'>
          <div className='promotionsCard'>
            <div className='box loader-05'>
              <div className='loader-05' />
            </div>
          </div>

          <div className='promotionsCard'>
            <div className='box loader-05'>
              <div className='loader-05' />
            </div>
          </div>

          <div className='promotionsCard'>
            <div className='box loader-05'>
              <div className='loader-05' />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromotionsLoader;
